import { Drawer, type DrawerProps } from '@chakra-ui/react';

export type UiDrawerProps = DrawerProps;

export const UiDrawer = Drawer;
